var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg",class:_vm.is_opaque ? 'is-opaque' : ''})}
var staticRenderFns = []

export { render, staticRenderFns }